import React from "react";

// reactstrap components
import {
    Table,
    Badge,
    Button,
    DropdownMenu,
    DropdownItem,
    Modal,
    UncontrolledDropdown,
    DropdownToggle,
} from "reactstrap";
import NumberFormat from 'react-number-format';
import ProductDataService from "../../services/ProductDataService";
import ProductSplitStockModal from "components/Modals/ProductSplitStock";
// import ProductStockUpdateModal from "components/Modals/ProductStockUpdate";

class Products extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            productToDisabled: {},
            splitStockProductModal: false,
            updateStockProductModal: false,
        }
        this.productDataService = new ProductDataService();
    }

    toggleModal = (product) => {
        this.props.toggleModal("formModal", "edit", product)
    }

    toggleModals = (state, product) => {
        this.setState({
            [state]: !this.state[state],
            productToDisabled: product,
        });
    };

    toggleSplitStockModal = (product) => {
        if (this.isAdmin()) {
            this.setState({
                ["splitStockProductModal"]: !this.state["splitStockProductModal"],
                currentProduct: {
                    ...product,
                },
            });
        }
    };

    toggleUpdateStockModal = (product) => {
        this.props.toggleModal("formModal", "edit", product, 'stock');
    };

    handleDisableProduct() {
        const status = this.props.tabs === 2 ? 0 : 1;

        this.productDataService.disable({
            ...this.state.productToDisabled,
            status
        }).then((data) => {
            this.handleResponse(data, this.props.tabs === 2 ? "Produk berhasil diaktifkan" : "Produk berhasil dinonaktifkan");
        });
    }

    handleResponse(data, successMessage) {
        if (data.header.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
                errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.toggleModals("disableProductModal")
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentProduct: {} })
            this.props.fetchData()
        }
    }

    productOnClick(product) {
        if (this.props.isPOS) {
            this.props.addToCart(product)
        } else {
            this.toggleModal(product);
        }
    }

    isAdmin() {
        return ((localStorage.getItem("user_roles")) || "")
            .split(',')
            .map(role => role.trim().toLowerCase())
            .some(role => role === "admin");
    }

    isCashier() {
        return ((localStorage.getItem("user_roles")) || "")
            .split(',')
            .map(role => role.trim().toLowerCase())
            .some(role => role === "cashier");
    }

    stockWarehouseLabel(product) {
        if (this.isAdmin()) {
            return product.warehouse_detail?.length > 0 ?
                'Available. Click to see/update stock' :
                'Unavailable. Click to split stock'
        }
        return product.warehouse_detail?.length > 0 ?
            'Available. Click to see/update stock' :
            'Unavailable. Contact admin to split stock'
    }

    render() {
        const productStatuses = ['Aktif', 'Tidak aktif'];
        return (
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                    <tr>
                        <th scope="col">Nama produk</th>
                        <th scope="col">Barcode produk</th>
                        <th scope="col">Harga produk</th>
                        <th scope="col">Harga jual produk</th>
                        {!this.props.isPOS && (<th scope="col">Stok produk</th>)}
                        <th scope="col">Stok warehouse</th>
                        <th scope="col">Supplier</th>
                        {!this.props.isPOS && (
                            <th scope="col">Status produk</th>
                        )}
                        {!this.props.isPOS && (
                            <th scope="col" />
                        )}
                    </tr>
                </thead>
                <tbody>
                    {this.props.products.length > 0 && this.props.products.filter(product => product).map((product) => (
                        <tr style={{ cursor: 'pointer' }}>
                            <th scope="row" onClick={() => this.productOnClick(product)}>
                                {product.product_name}
                            </th>
                            <td onClick={() => this.productOnClick(product)}>
                                {product.product_barcode}
                            </td>
                            <td onClick={() => this.productOnClick(product)}>
                                <NumberFormat value={product.price} displayType={'text'} thousandSeparator={true} prefix={'Rp.'} suffix={',00'} />
                            </td>
                            <td onClick={() => this.productOnClick(product)}>
                                <NumberFormat value={product.sell_price} displayType={'text'} thousandSeparator={true} prefix={'Rp.'} suffix={',00'} />
                            </td>
                            {!this.props.isPOS && (
                                <td onClick={() => this.productOnClick(product)}>{product.product_stock}</td>
                            )}
                            {this.props.isPOS && (
                                <td onClick={() => this.productOnClick(product)}>{product.stock_warehouse}</td>
                            )}
                            {!this.props.isPOS && (
                                <td onClick={() => {
                                    if (product.warehouse_detail?.length > 0) {
                                        this.toggleUpdateStockModal(product);
                                    } else {
                                        this.toggleSplitStockModal(product);
                                    }
                                }}>
                                    <Badge
                                        color={product.warehouse_detail?.length > 0 ? "success" : "warning"}
                                    >
                                        {this.stockWarehouseLabel(product)}
                                    </Badge>
                                </td>
                            )}
                            <td onClick={() => this.productOnClick(product)}>{product.supplier}</td>
                            {!this.props.isPOS && (
                                <td onClick={() => this.toggleModal(product)}>
                                    <Badge color="" className="badge-dot mr-4">
                                        <i className={product.status === 0 ? "bg-info" : "bg-warning"} />
                                        {productStatuses[product.status]}
                                    </Badge>
                                </td>
                            )}
                            {!this.props.isPOS && (
                                <td className="text-right">
                                    <UncontrolledDropdown>
                                        <DropdownToggle
                                            className="btn-icon-only text-light"
                                            role="button"
                                            size="sm"
                                            color=""
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <i className="fas fa-ellipsis-v" />
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-arrow" right>
                                            <DropdownItem
                                                onClick={() => this.toggleModal(product)}
                                            >
                                                Ubah
                                            </DropdownItem>
                                            {/*{(!!product.warehouse_detail && (this.isAdmin() || this.isCashier())) && (*/}
                                            {/*    <DropdownItem*/}
                                            {/*        onClick={() => this.toggleUpdateStockModal(product)}*/}
                                            {/*    >*/}
                                            {/*        Ubah Stock*/}
                                            {/*    </DropdownItem>*/}
                                            {/*)}*/}
                                            {((product.warehouse_detail === undefined || product.warehouse_detail?.length === 0) && (
                                                <DropdownItem
                                                    onClick={() => this.toggleSplitStockModal(product)}>
                                                    Split Stok
                                                </DropdownItem>
                                            ))}
                                            <DropdownItem
                                                onClick={() => this.toggleModals("disableProductModal", product)}>
                                                {this.props.tabs === 2 ? "Aktifkan" : "Nonaktifkan"}
                                            </DropdownItem>
                                        </DropdownMenu>
                                        <ProductSplitStockModal
                                            toggleModal={() => this.toggleSplitStockModal(product)}
                                            formModal={this.state.splitStockProductModal}
                                            currentProduct={this.state.currentProduct}
                                            setSuccessMessage={this.props.setSuccessMessage}
                                            fetchData={this.props.fetchData.bind(this)}
                                            warehouses={this.props.warehouses}
                                        />
                                        <Modal
                                            className="modal-dialog-centered modal-danger"
                                            contentClassName="bg-gradient-danger"
                                            isOpen={this.state.disableProductModal}
                                            toggle={() => this.toggleModals("disableProductModal")}
                                        >
                                            <div className="modal-header">
                                                <button
                                                    aria-label="Close"
                                                    className="close"
                                                    data-dismiss="modal"
                                                    type="button"
                                                    onClick={() => this.toggleModals("disableProductModal")}
                                                >
                                                    <span aria-hidden={true}>×</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <div className="py-3 text-center">
                                                    <i className="ni ni-bell-55 ni-3x" />
                                                    <h4 className="heading mt-4">Anda akan <strong>{this.props.tabs === 2 ? "mengaktifkan" : "menonaktifkan"}</strong> produk berikut</h4>
                                                    <p>
                                                        Nama produk <b>{this.state.productToDisabled?.product_name}</b> <br />Barcode <b>{this.state.productToDisabled?.product_barcode}</b>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <Button
                                                    className="text-white ml-auto"
                                                    color="link"
                                                    data-dismiss="modal"
                                                    type="button"
                                                    onClick={() => this.toggleModals("disableProductModal")}
                                                >
                                                    Batal
                                                </Button>
                                                <Button
                                                    className="btn-white"
                                                    color="default"
                                                    type="button"
                                                    onClick={() => this.handleDisableProduct()}
                                                >
                                                    {this.props.tabs === 2 ? "Aktifkan" : "Nonaktifkan"}
                                                </Button>
                                            </div>
                                        </Modal>
                                    </UncontrolledDropdown>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </Table>
        )
    };
}

export default Products;
